import { createNavigation } from "next-intl/navigation";
import { defineRouting } from "next-intl/routing";

import { BE_LOCALES, DEFAULT_LOCALE, LOCALES, LU_LOCALES } from "consts/locale";
import { HOSTS } from "server/hosts";

export const routing = defineRouting({
  locales: LOCALES,
  defaultLocale: DEFAULT_LOCALE,
  localeDetection: false,
  alternateLinks: false, // Disable header alternate's
  localePrefix: {
    mode: "always",
    prefixes: {
      "nl-BE": "/nl",
      "fr-BE": "/fr",
      "en-BE": "/en",
      "fr-LU": "/fr",
      "de-LU": "/de",
      "en-LU": "/en",
    },
  },
  pathnames: {
    "/": "/",

    // For who
    "/for-who": {
      "nl-BE": "/voor-wie",
      "fr-BE": "/pour-qui",
      "en-BE": "/for-who",
      "fr-LU": "/pour-qui",
      "de-LU": "/for-who",
      "en-LU": "/for-who",
    },
    "/for-who/[slug]": {
      "nl-BE": "/voor-wie/[slug]",
      "fr-BE": "/pour-qui/[slug]",
      "en-BE": "/for-who/[slug]",
      "fr-LU": "/pour-qui/[slug]",
      "de-LU": "/for-who/[slug]",
      "en-LU": "/for-who/[slug]",
    },

    // Nearby
    "/nearby": {
      "nl-BE": "/in-de-buurt",
      "fr-BE": "/proche-de-vous",
      "en-BE": "/nearby",
      "fr-LU": "/proche-de-vous",
      "de-LU": "/nearby",
      "en-LU": "/nearby",
    },
    "/nearby/[slug]": {
      "nl-BE": "/in-de-buurt/[slug]",
      "fr-BE": "/proche-de-vous/[slug]",
      "en-BE": "/nearby/[slug]",
      "fr-LU": "/proche-de-vous/[slug]",
      "de-LU": "/nearby/[slug]",
      "en-LU": "/nearby/[slug]",
    },

    // Offices
    "/offices": {
      "nl-BE": "/kantoren",
      "fr-BE": "/bureaus",
      "en-BE": "/offices",
      "fr-LU": "/bureaus",
      "de-LU": "/offices",
      "en-LU": "/offices",
    },
    "/offices/[...slug]": {
      "nl-BE": "/kantoren/[...slug]",
      "fr-BE": "/bureaus/[...slug]",
      "en-BE": "/offices/[...slug]",
      "fr-LU": "/bureaus/[...slug]",
      "de-LU": "/offices/[...slug]",
      "en-LU": "/offices/[...slug]",
    },

    // Career
    "/career": {
      "nl-BE": "/carriere",
      "fr-BE": "/profession",
      "en-BE": "/career",
      "fr-LU": "/profession",
      "de-LU": "/career",
      "en-LU": "/career",
    },
    "/career/jobs": {
      "nl-BE": "/carriere/vacatures",
      "fr-BE": "/profession/jobs",
      "en-BE": "/career/jobs",
      "fr-LU": "/profession/jobs",
      "de-LU": "/career/jobs",
      "en-LU": "/career/jobs",
    },
    "/career/jobs/[slug]": {
      "nl-BE": "/carriere/vacatures/[slug]",
      "fr-BE": "/profession/jobs/[slug]",
      "en-BE": "/career/jobs/[slug]",
      "fr-LU": "/profession/jobs/[slug]",
      "de-LU": "/career/jobs/[slug]",
      "en-LU": "/career/jobs/[slug]",
    },

    // News
    "/news": {
      "nl-BE": "/nieuws",
      "fr-BE": "/nouvelles",
      "en-BE": "/news",
      "fr-LU": "/nouvelles",
      "de-LU": "/news",
      "en-LU": "/news",
    },
    "/news/[slug]": {
      "nl-BE": "/nieuws/[slug]",
      "fr-BE": "/nouvelles/[slug]",
      "en-BE": "/news/[slug]",
      "fr-LU": "/nouvelles/[slug]",
      "de-LU": "/news/[slug]",
      "en-LU": "/news/[slug]",
    },

    // Author
    "/author": {
      "nl-BE": "/auteur",
      "fr-BE": "/auteur",
      "en-BE": "/author",
      "fr-LU": "/auteur",
      "de-LU": "/autor",
      "en-LU": "/author",
    },
    "/author/[slug]": {
      "nl-BE": "/auteur/[slug]",
      "fr-BE": "/auteur/[slug]",
      "en-BE": "/author/[slug]",
      "fr-LU": "/auteur/[slug]",
      "de-LU": "/autor/[slug]",
      "en-LU": "/author/[slug]",
    },

    // Reviewer
    "/reviewer": {
      "nl-BE": "/reviewer",
      "fr-BE": "/reviewer",
      "en-BE": "/reviewer",
      "fr-LU": "/reviewer",
      "de-LU": "/reviewer",
      "en-LU": "/reviewer",
    },
    "/reviewer/[slug]": {
      "nl-BE": "/reviewer/[slug]",
      "fr-BE": "/reviewer/[slug]",
      "en-BE": "/reviewer/[slug]",
      "fr-LU": "/reviewer/[slug]",
      "de-LU": "/reviewer/[slug]",
      "en-LU": "/reviewer/[slug]",
    },

    // Municipalities
    "/municipalities": {
      "nl-BE": "/gemeenten",
      "fr-BE": "/communes",
      "en-BE": "/municipalities",
      "fr-LU": "/communes",
      "de-LU": "/municipalities",
      "en-LU": "/municipalities",
    },

    // Search
    "/search": {
      "nl-BE": "/zoeken",
      "fr-BE": "/chercher",
      "en-BE": "/search",
      "fr-LU": "/chercher",
      "de-LU": "/suchen",
      "en-LU": "/search",
    },

    // Expertises
    "/expertises": {
      "nl-BE": "/expertises",
      "fr-BE": "/secteurs",
      "en-BE": "/expertises",
      "fr-LU": "/secteurs",
      "de-LU": "/expertises",
      "en-LU": "/expertises",
    },
    "/expertises/[slug]": {
      "nl-BE": "/expertises/[slug]",
      "fr-BE": "/secteurs/[slug]",
      "en-BE": "/expertises/[slug]",
      "fr-LU": "/secteurs/[slug]",
      "de-LU": "/expertises/[slug]",
      "en-LU": "/expertises/[slug]",
    },

    // Accountancy
    "/accountancy": {
      "nl-BE": "/accountancy",
      "fr-BE": "/comptabilite",
      "en-BE": "/accountancy",
      "fr-LU": "/comptabilite",
      "de-LU": "/accountancy",
      "en-LU": "/accountancy",
    },

    /**
     * Internal segment is `services` (matches `app/[locale]/services`). BE locales keep the
     * public URL `/pia-advisory`; LU uses `/services` so the public path matches the app folder.
     */
    "/services": {
      "nl-BE": "/pia-advisory",
      "fr-BE": "/pia-advisory",
      "en-BE": "/pia-advisory",
      "fr-LU": "/services",
      "de-LU": "/dienstleistungen",
      "en-LU": "/services",
    },
    "/services/[...slug]": {
      "nl-BE": "/pia-advisory/[...slug]",
      "fr-BE": "/pia-advisory/[...slug]",
      "en-BE": "/pia-advisory/[...slug]",
      "fr-LU": "/services/[...slug]",
      "de-LU": "/dienstleistungen/[...slug]",
      "en-LU": "/services/[...slug]",
    },
    "/audit": "/audit",
    "/audit/[slug]": "/audit/[slug]",
    "/contact/[slug]": "/contact/[slug]",
    "/[...slug]": "/[...slug]",
  },
  domains: [
    ...HOSTS.be.map((domain) => ({
      domain,
      defaultLocale: "nl-BE" as const,
      locales: BE_LOCALES,
    })),
    ...HOSTS.lu.map((domain) => ({
      domain,
      defaultLocale: "fr-LU" as const,
      locales: LU_LOCALES,
    })),
  ],
});

export const { Link, redirect, usePathname, useRouter, getPathname } = createNavigation(routing);
